const themeRoot = {}
export default themeRoot
